import { useEffect, useState } from 'react'

// Relógio que re-renderiza o componente a cada `intervalMs` (contagens regressivas)
export function useNow(intervalMs = 1000) {
	const [now, setNow] = useState(() => Date.now())
	useEffect(() => {
		const id = setInterval(() => setNow(Date.now()), intervalMs)
		return () => clearInterval(id)
	}, [intervalMs])
	return now
}
